import { forwardRef, HTMLAttributes } from 'react'

import { cn } from '@shared/lib/cn'

import styles from './styles.module.scss'



interface WrapperProps extends HTMLAttributes<HTMLDivElement> {
  className?: string;
}

const Wrapper = forwardRef<HTMLDivElement, WrapperProps>((props, ref) => {
  const { className, children, ...rest } = props

  return (
    <div ref={ref} className={cn(styles.root, className)} {...rest}>
      {children}
    </div>
  )
})

Wrapper.displayName = 'Wrapper'

export default Wrapper
